<template>
  <LeadHistoryCard
    v-model:pick-up-call-target-id="pickUpCallTargetId"
    :call-target-id="callTargetId"
    :history="unsubscribeItem"
    :text="unsubscribeItem?.title"
    :icon="icon.fileName"
    :icon-type="icon.type"
    :expand="expand"
    :event-emotion="icon.eventEmotion"
    :call-target="callTarget"
    is-event
  >
    <template #date>
      <div>{{ historiedAt }}</div>
    </template>
    <BListItem class="mb-400">
      <template #header>
        <div>{{ $t('mailEvent.unsubscribedEmail') }}</div>
      </template>
      <div>{{ historiedEmail }}</div>
    </BListItem>
  </LeadHistoryCard>
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import type { CallTarget, HistoryCommon } from '@/api/openapi';
import LeadHistoryCard from '@/components/organisms/user/lead/history/LeadHistoryCard.vue';
import { formatShorterDateTime } from '@/utils/date-time';

type TProps = {
  callTargetId: number;
  unsubscribeItem?: HistoryCommon & {
    title: string;
    email: string;
    historiedAt: string;
  };
  callTarget?: CallTarget;
  expand?: boolean;
}

const props = defineProps<TProps>();
defineOptions({
  inheritAttrs: false,
});

// v-model for pickUpCallTargetId to pass through to parent
const pickUpCallTargetId = defineModel<number>('pickUpCallTargetId');

const icon = computed(() => ({
  fileName: 'unsubscribe',
  type: 'cold',
  eventEmotion: 'negative',
}));

const historiedEmail = computed(() => {
  return props.unsubscribeItem?.email;
});

const historiedAt = computed(() => {
  return formatShorterDateTime(props.unsubscribeItem?.historiedAt ?? '');
});
</script>
